export enum PlatformType {
    Unknown = "unknown",
    Android = "android",
    iOS = "iphone"
}

export const getPlatform = (): PlatformType => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.indexOf(PlatformType.Android) > -1)
        return PlatformType.Android;
    else if (userAgent.indexOf(PlatformType.iOS) > -1)
        return PlatformType.iOS;

    return PlatformType.Unknown;
}